import {ProposalStatusDropdown} from "../../form/dropdown/ProposalStatusDropdown";
import {Proposal, ProposalStatus} from "../../../types/Proposal";
import {ProposalFilter, updateProposalStatus} from "../../../service/proposal.service";
import {Page} from "../../../types/Page";
import {ProposalStatusBadge} from "../ProposalStatusBadge";
import React from "react";
import {User} from "../../../types/User";
import {useQueryClient} from "@tanstack/react-query";
import {useAuthStore} from "../../../store/auth.store";

interface Props {
    row: Proposal,
    containMyPhone: boolean,
    filter: ProposalFilter
}

export function ProposalStatusCell({
                                       row,
                                       containMyPhone,
                                       filter
                                   }: Props) {

    const { can, jwt, user } = useAuthStore();
    const canManage = can('manage_proposals');
    const queryClient = useQueryClient();
    const canEdit = canManage
        || (user && user.id && row.createdBy === user.id)
        || containMyPhone;
    if (canEdit) {
        return <ProposalStatusDropdown
            single
            onChange={p => {
                if (p.length) {
                    const newValue = p[p.length - 1] as ProposalStatus;
                    updateProposalStatus(row.id, newValue).then((response) => {
                        const updated = response.data;
                        queryClient.setQueryData(['proposals', filter, jwt], (oldData: Page<Proposal>) => {
                            if (!oldData || !oldData.content) return oldData;
                            return {
                                ...oldData,
                                content: oldData.content.map((item) =>
                                    item.id === row.id
                                        ? {...updated}
                                        : item
                                ),
                            }
                        })
                    })
                }
            }}
            value={[row.proposalStatus]}/>
    }
    return <ProposalStatusBadge status={row.proposalStatus}/>
}